// extracted by mini-css-extract-plugin
export default {"modal":"formModal_modal__LWj36","vertical":"formModal_vertical__oG9yZ","body":"formModal_body__yxdXL"};